import React, { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth, apiError } from "@/context/AuthContext";
import { toast } from "sonner";
import AuthLayout, { Field, SubmitButton } from "@/pages/AuthLayout";

export default function Register() {
  const { register } = useAuth();
  const navigate = useNavigate();
  const [form, setForm] = useState({ name: "", email: "", mobile: "", password: "" });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState("");

  const set = (k) => (e) => setForm({ ...form, [k]: e.target.value });

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError("");
    try {
      const res = await register(form);
      if (res.mock_mobile_code) {
        sessionStorage.setItem("mock_mobile_code", res.mock_mobile_code);
      }
      toast.success("Account created. Verify to continue.");
      navigate("/verify");
    } catch (e2) {
      setError(apiError(e2.response?.data?.detail) || e2.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout title="Create your account" subtitle="Register as a patient to begin voice screening."
      image="https://images.unsplash.com/photo-1665396697251-05a3a49515a7">
      <form onSubmit={submit} data-testid="register-form">
        <Field label="Full name" required value={form.name} onChange={set("name")} data-testid="register-name" placeholder="Asha Kumar" />
        <Field label="Email" type="email" required value={form.email} onChange={set("email")} data-testid="register-email" placeholder="you@example.com" />
        <Field label="Mobile (optional)" value={form.mobile} onChange={set("mobile")} data-testid="register-mobile" placeholder="+1 555 000 0000" />
        <Field label="Password" type="password" required minLength={6} value={form.password} onChange={set("password")} data-testid="register-password" placeholder="At least 6 characters" />
        {error && <p className="text-sm text-red-600 mb-3" data-testid="register-error">{error}</p>}
        <SubmitButton loading={loading} type="submit" data-testid="register-submit">Create account</SubmitButton>
      </form>
      <p className="mt-4 text-sm text-ink-soft">
        Already registered? <Link to="/login" className="text-brand font-medium hover:underline">Sign in</Link>
      </p>
    </AuthLayout>
  );
}
